import { render, staticRenderFns } from "./emails.vue?vue&type=template&id=de2df84c&scoped=true&"
import script from "./emails.vue?vue&type=script&lang=js&"
export * from "./emails.vue?vue&type=script&lang=js&"
import style0 from "./emails.vue?vue&type=style&index=0&id=de2df84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2df84c",
  null
  
)

export default component.exports